/* eslint-disable import/no-unresolved */
export { unstable_batchedUpdates } from 'react-dom';


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/es/utils/reactBatchedUpdates.js
// module id = d3Kz
// module chunks = 0